import * as API from 'utils/api'
import HTTPStatus from 'http-status'
import { push } from "react-router-redux"

const loginWithTokenRequest = () => ({
  type: "LOGIN_WITH_TOKEN_REQUEST",
  auth: true
})

const loginSuccess = () => ({
  type: "LOGIN_SUCCESS"
})

const loginWithTokenSuccess = () => ({
  type: "LOGIN_WITH_TOKEN_SUCCESS"
})

const loginFailure = () => ({
  type: "LOGIN_FAILURE"
})

const loginWithTokenFailure = () => ({
  type: "LOGIN_WITH_TOKEN_FAILURE"
})

const logoutSuccess = () => ({
  type: "LOGOUT_SUCCESS"
})

export const login = (credentials) => async dispatch => {
  const config = { body: JSON.stringify({ ...credentials }) }
  const response = await API.post(`/auth/login`, config)
  switch (response.status) {
    case HTTPStatus.OK:
      const token = await response.json()
      localStorage.setItem('token', token.token)
      dispatch(loginSuccess())
      dispatch(push("/admin/companies"))
      break;
    default:
      dispatch(loginFailure())
      break;
  }
}

export const loginWithToken = (callback) => async dispatch => {
  dispatch(loginWithTokenRequest())
  const response = await API.get(`/auth/verify`)

  switch (response.status) {
    case HTTPStatus.OK:
      dispatch(loginWithTokenSuccess())
      callback()
      break;
    default:
      dispatch(loginWithTokenFailure())
      break;
  }
}

export const logout = () => async dispatch => {
  localStorage.removeItem("token")
  dispatch(logoutSuccess())
  dispatch(push("/admin"))
}


// WEBPACK FOOTER //
// src/data/auth/actions.js